import React from 'react';
import { Link } from 'react-router-dom';

export function EmptyExchangeNotice({
  tokenInSymbol,
  tokenOutSymbol,
  amount,
  where,
}: {
  tokenInSymbol?: string;
  tokenOutSymbol?: string;
  amount?: string;
  where: 'swap' | 'pools' | 'clmm' | 'stock';
}) {
  const pair =
    tokenInSymbol && tokenOutSymbol
      ? `${amount ? `${amount} ` : ''}${tokenInSymbol} → ${tokenOutSymbol}`
      : 'The starting pair';
  const body =
    where === 'swap'
      ? `${pair} is what this page opens on. This exchange has no pools yet, so there is nothing to quote. Token lists and activity stay empty until the first pool is created.`
      : where === 'clmm'
      ? 'No CLMM pools yet. Token lists and activity stay empty until the first pool is created.'
      : where === 'stock'
      ? 'No stock pools yet. Token lists and activity stay empty until the first pool is created.'
      : 'No classic pools yet. Token lists and activity stay empty until the first pool is created.';
  const createTo = where === 'clmm' ? '/pools/add-v4' : '/pools/add';

  return (
    <div
      className="px-4 py-3 mb-3 text-sm text-primaryText"
      style={{
        background: 'rgba(14, 20, 38, 0.86)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 18,
      }}
    >
      <div className="text-white mb-1" style={{ fontWeight: 600 }}>
        No pools yet
      </div>
      <p className="mb-2" style={{ lineHeight: 1.45 }}>
        {body}
      </p>
      <Link to={createTo} className="text-gradientFrom">
        Create a pool
      </Link>
    </div>
  );
}
